import { Button } from '@components/Button';
import { BigHeader, TopDefault } from './styles';

interface FilterTopSectionProps {
  heading: string;
  onClose: () => void;
}
const FilterTopSection = ({ heading, onClose }: FilterTopSectionProps) => {
  return (
    <>
      <TopDefault>
        <BigHeader>{heading}</BigHeader>
        <Button
          variant="iconOnly"
          onClickHandler={() => onClose()}
          arrow={false}
          label="Close"
          icon="Close"
          iconSize="36px"
        />
      </TopDefault>
    </>
  );
};

export default FilterTopSection;
